import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import React from 'react';
import { Image as Icon } from 'components/Image/Image';
import { Image } from 'antd';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { NAVIGATION } from 'externals/_tracking/types/clickEventTypes.constants';
import { openNewTab } from 'helpers/domHelper';
import { useSeenOfferPixel } from 'hook/helper.hook';
import { getSeenOfferActionTrackingAttributes } from 'helpers/tracking.helpers';
import { factorMapping } from 'customHelpersPath/factorMapping.helper';
import { boldPoints } from 'helpers/string.helper';
import { CardsConfig } from 'goals_card_config/config';
import { VERTICAL_OFFER_TYPE_MAP } from 'types/marketplaceTiles.constants.js';
import classname from 'classnames';
import OText from 'components/CText/OText';

const FactorActionComponent = props => {
  const {
    text,
    image,
    icon,
    url,
    isExternalPath,
    history,
    name,
    eventHandler,
    offerModulePosition,
    offer,
    selectedFactor,
    seenOfferModuleName,
    seenOfferModulePosition,
    clickType,
    avoidSeenOfferPixel,
    config,
  } = props;
  const onClickGoToActionDetails = () => {
    eventHandler(CLICK, {
      'Click Type': clickType ? clickType : NAVIGATION,
      'Action Name': 'Action ' + CardsConfig[name]?.moduleName,
      'Module Position': seenOfferModulePosition || 1,
      'Offer Module Position': offerModulePosition,
      Vertical: VERTICAL_OFFER_TYPE_MAP[offer?.offerType],
      Partner: offer?.name,
      'Product Key': offer?.productKey,
      'Module Name':
        (seenOfferModuleName || 'Grade Dial 3B - ') +
        `${' - '}` +
        factorMapping?.get(selectedFactor),
    });
    isExternalPath ? openNewTab(url) : history.push(url);
  };

  const attributes = {
    action: CardsConfig[name]?.moduleName,
    offerModulePosition: offerModulePosition,
    modulePosition: seenOfferModulePosition || 1,
    moduleName:
      (seenOfferModuleName || 'Grade Dial 3B - ') +
      `${' - '}` +
      factorMapping?.get(selectedFactor),
    moduleHeading: props.moduleHeading,
    vertical: VERTICAL_OFFER_TYPE_MAP[offer?.offerType],
    moduleMetadata: props.moduleMetadata,
  };

  const trackingAttributes = getSeenOfferActionTrackingAttributes(attributes);
  const seenOfferPixel = useSeenOfferPixel(trackingAttributes);
  const classes = classname('Subtitle-3 system_neutral_n400_text', {
    bold: config?.highlightedActionSubtitle,
  });
  return (
    <FlexContainer
      className={
        'flex-container margt10 border-rad8px system_neutral_n000 grayShadow16 format100 padTB16 padLR16 m-padLR8 items-align-center pointer'
      }
      onClick={() => onClickGoToActionDetails()}
    >
      {avoidSeenOfferPixel || seenOfferPixel}
      <FlexContainer className={'format20'}>
        {image && (
          <Image src={image?.src} alt={''} width={60} preview={false} />
        )}
        {!image && <Icon className={icon} />}
      </FlexContainer>
      <FlexContainer className={'format70'}>
        <Label className={classes}>
          <OText text={boldPoints(text)}></OText>
        </Label>
      </FlexContainer>
      <FlexContainer className={'format10'}>
        <Icon className={'notificationChevronRight'} />
      </FlexContainer>
    </FlexContainer>
  );
};

export default FactorActionComponent;
